export const numericalPatterns = [
  /* --------------------- # -------------------- */
  {
    value: "1 2 3 4 5",
    label: "1 2 3 4 5",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, false],
      I: [true, true, false, false, false],
      N: [true, true, true, false, false],
      G: [true, true, true, true, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, false, false, false, false],
        I: [true, true, false, false, false],
        N: [true, true, true, false, false],
        G: [true, true, true, true, false],
        O: [true, true, true, true, true],
      },
      {
        B: [false, false, true, false, false],
        I: [false, true, true, false, false],
        N: [false, true, true, true, false],
        G: [true, true, true, false, true],
        O: [true, true, true, true, true],
      },
      {
        B: [false, false, false, false, true],
        I: [true, false, false, false, true],
        N: [true, false, true, false, true],
        G: [true, true, false, true, true],
        O: [true, true, true, true, true],
      },
      {
        B: [false, false, false, true, false],
        I: [false, true, true, false, false],
        N: [false, false, true, true, true],
        G: [false, true, true, true, true],
        O: [true, true, true, true, true],
      },
    ],
  },
  {
    value: "1 Corner Postage Stamp",
    label: "1 Corner Postage Stamp",
    otherNames: ["One Stamp", "One Corner Postage Stamp", "One Postage Stamp", "1 Stamp", "1 Postage Stamp"],
    pattern: {
      B: [true, true, false, false, false],
      I: [true, true, false, false, false],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    winningPatterns: [
      {
        B: [true, true, false, false, false],
        I: [true, true, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [true, true, false, false, false],
        O: [true, true, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, true, true],
        O: [false, false, false, true, true],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
    ],
    unusedLetters: ["N"],
    credit: "Bret Rice",
  },
  {
    value: "1 Hardway & 1 Easyway Bingo",
    label: "1 Hardway & 1 Easyway Bingo",
    otherNames: [],
    pattern: {
      B: [false, false, true, false, true],
      I: [false, false, true, false, true],
      N: [false, false, true, false, true],
      G: [false, false, true, false, true],
      O: [false, false, true, false, true],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [false, false, false, false, true],
        I: [false, false, false, true, false],
        N: [false, false, true, false, false],
        G: [true, true, true, true, true],
        O: [true, false, false, false, false],
      },
      {
        B: [true, true, false, false, false],
        I: [false, true, false, false, false],
        N: [false, true, true, false, false],
        G: [false, true, false, true, false],
        O: [false, true, false, false, true],
      },
      {
        B: [false, false, false, false, false],
        I: [true, true, true, true, true],
        N: [true, true, true, true, true],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, true],
        I: [false, false, false, false, true],
        N: [true, true, true, true, true],
        G: [false, false, false, false, true],
        O: [false, false, false, false, true],
      },
      {
        B: [false, false, true, false, false],
        I: [false, false, true, false, false],
        N: [false, false, true, false, false],
        G: [false, false, true, false, false],
        O: [true, true, true, true, true],
      },
    ],
  },
  {
    value: "1 Line & Block Of Four",
    label: "1 Line & Block Of Four",
    otherNames: [],
    pattern: {
      B: [true, true, false, true, false],
      I: [true, true, false, true, false],
      N: [false, false, false, true, false],
      G: [false, false, false, true, false],
      O: [false, false, false, true, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, true, false, false, false],
        I: [true, true, false, false, false],
        N: [false, false, true, false, false],
        G: [false, false, false, true, false],
        O: [false, false, false, false, true],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [false, false, false, false, false],
        G: [true, true, true, true, true],
        O: [false, false, false, false, false],
      },
    ],
  },
  {
    value: "12 Days Of Christmas",
    label: "12 Days Of Christmas",
    otherNames: [],
    pattern: {
      B: [true, false, true, true, false],
      I: [false, false, true, true, false],
      N: [true, true, false, false, true],
      G: [false, false, false, true, true],
      O: [false, true, false, false, true],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, false, true, true, false],
        I: [false, false, true, true, false],
        N: [true, true, false, false, true],
        G: [false, false, false, true, true],
        O: [false, true, false, false, true],
      },
      { B: [false, true, false, false, true], I: [true, false, true, false, true], N: [false, false, false, true, false], G: [false, true, true, false, false], O: [true, true, true, false, true] },
      { B: [false, false, true, false, true], I: [true, false, true, true, true], N: [false, true, false, true, false], G: [false, false, true, false, false], O: [true, true, false, false, true] },
      { B: [true, true, false, false, true], I: [false, false, true, false, false], N: [false, true, false, true, true], G: [true, false, true, false, true], O: [true, false, false, true, false] },
      { B: [false, false, true, true, false], I: [true, true, false, false, true], N: [false, true, false, true, false], G: [true, false, false, true, false], O: [true, false, true, false, true] },
      { B: [true, true, true, false, false], I: [false, true, true, false, true], N: [true, false, false, true, false], G: [false, false, true, false, true], O: [false, true, false, false, true] },
      { B: [true, false, false, false, true], I: [false, false, true, false, false], N: [false, true, false, true, true], G: [true, true, true, true, false], O: [true, false, false, false, true] },
      { B: [false, true, false, false, true], I: [true, true, false, true, false], N: [true, false, false, true, true], G: [false, true, false, true, false], O: [false, true, true, false, false] },
      { B: [true, true, false, true, true], I: [false, false, true, false, false], N: [false, true, false, true, true], G: [false, false, true, false, true], O: [true, false, false, true, false] },
      { B: [false, true, false, false, true], I: [true, true, false, true, false], N: [false, true, false, false, true], G: [true, false, false, true, true], O: [false, true, true, false, false] },
      { B: [true, false, false, true, true], I: [false, true, true, false, true], N: [true, false, false, true, false], G: [false, false, false, true, false], O: [true, true, false, false, true] },
      { B: [false, true, false, false, true], I: [true, true, true, true, false], N: [false, true, false, true, false], G: [true, false, true, false, true], O: [false, true, false, false, false] },
    ],
  },
  {
    value: "12 Dots",
    label: "12 Dots",
    otherNames: ["12 Dotes"],
    pattern: {
      B: [true, false, true, false, true],
      I: [false, false, true, false, false],
      N: [true, true, false, true, true],
      G: [false, false, true, false, false],
      O: [true, false, true, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "12 Dots (Reversed)",
    label: "12 Dots (Reversed)",
    otherNames: ["12 Reverse"],
    pattern: {
      B: [false, true, false, true, false],
      I: [true, true, false, true, true],
      N: [false, false, false, false, false],
      G: [true, true, false, true, true],
      O: [false, true, false, true, false],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "1K",
    label: "1K",
    otherNames: [],
    pattern: {
      B: [false, true, false, false, false],
      I: [true, true, true, true, true],
      N: [false, false, true, false, false],
      G: [false, true, false, true, false],
      O: [true, false, false, false, true],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "10/2/4",
    label: "10/2/4",
    otherNames: ["Ten Two Four"],
    pattern: {
      B: [true, false, true, false, true],
      I: [false, true, false, true, false],
      N: [true, false, true, false, true],
      G: [true, false, false, true, true],
      O: [true, false, false, true, true],
    },
    unusedLetters: [],
    credit: "Norma Davis",
  },
  {
    value: "20 Ways",
    label: "20 Ways",
    otherNames: ["Twenty Ways"],
    pattern: {
      B: [false, false, false, true, true],
      I: [false, false, false, true, true],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      { B: [false, true, false, false, false], I: [false, true, false, false, false], N: [false, true, false, false, false], G: [false, true, false, false, false], O: [false, true, false, false, false] },
      { B: [false, false, true, false, false], I: [false, false, true, false, false], N: [false, false, true, false, false], G: [false, false, true, false, false], O: [false, false, true, false, false] },
      { B: [false, false, false, true, false], I: [false, false, false, true, false], N: [false, false, false, true, false], G: [false, false, false, true, false], O: [false, false, false, true, false] },
      { B: [false, false, false, false, true], I: [false, false, false, false, true], N: [false, false, false, false, true], G: [false, false, false, false, true], O: [false, false, false, false, true] },
      { B: [true, true, true, true, true], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [true, true, true, true, true], N: [false, false, false, false, false], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [true, true, true, true, true], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [true, true, true, true, true], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [false, false, false, false, false], O: [true, true, true, true, true] },
      { B: [true, false, false, false, false], I: [false, true, false, false, false], N: [false, false, true, false, false], G: [false, false, false, true, false], O: [false, false, false, false, true] },
      { B: [false, false, false, false, true], I: [false, false, false, true, false], N: [false, false, true, false, false], G: [false, true, false, false, false], O: [true, false, false, false, false] },
      { B: [true, true, false, false, false], I: [true, true, false, false, false], N: [false, false, false, false, false], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [true, true, false, false, false], O: [true, true, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [false, false, false, true, true], O: [false, false, false, true, true] },
      { B: [true, false, false, false, true], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [false, false, false, false, false], O: [true, false, false, false, true] },
      { B: [false, false, false, false, false], I: [false, true, false, true, false], N: [false, false, false, false, false], G: [false, true, false, true, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, true, false, false], N: [false, true, false, true, false], G: [false, false, true, false, false], O: [false, false, false, false, false] },
      { B: [false, false, true, false, false], I: [false, false, false, false, false], N: [true, false, false, false, true], G: [false, false, false, false, false], O: [false, false, true, false, false] },
      { B: [true, false, false, false, false], I: [true, false, false, false, false], N: [true, false, false, false, false], G: [true, false, false, false, false], O: [true, false, false, false, false] },
    ],
  },
  {
    value: "2 Bottom Lines",
    label: "2 Bottom Lines",
    otherNames: [],
    pattern: {
      B: [false, false, false, true, true],
      I: [false, false, false, true, true],
      N: [false, false, false, true, true],
      G: [false, false, false, true, true],
      O: [false, false, false, true, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "2 Corner Postage Stamps",
    label: "2 Corner Postage Stamps",
    otherNames: [],
    pattern: {
      B: [true, true, false, false, false],
      I: [true, true, false, false, false],
      N: [false, false, false, false, false],
      G: [true, true, false, false, false],
      O: [true, true, false, false, false],
    },
    winningPatterns: [
      {
        B: [true, true, false, false, false],
        I: [true, true, false, false, false],
        N: [false, false, false, false, false],
        G: [true, true, false, false, false],
        O: [true, true, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [true, true, false, true, true],
        O: [true, true, false, true, true],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, true, true],
        O: [false, false, false, true, true],
      },
      {
        B: [true, true, false, true, true],
        I: [true, true, false, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [true, true, false, false, false],
        I: [true, true, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, true, true],
        O: [false, false, false, true, true],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [false, false, false, false, false],
        G: [true, true, false, false, false],
        O: [true, true, false, false, false],
      },
    ],
    unusedLetters: ["N"],
    credit: "JoAnn Elizabeth Reinhardt",
  },
  {
    value: "2 Crazy Small Stamps",
    label: "2 Crazy Small Stamps",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [false, true, true, false, false],
      G: [false, true, true, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, true, true, false, false],
        G: [false, true, true, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [true, true, false, false, false],
        I: [true, true, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, true, true],
        G: [false, false, false, true, true],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, true, true, false],
        I: [false, false, true, true, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
    ],
  },
  {
    value: "2 Kites",
    label: "2 Kites",
    otherNames: [],
    pattern: {
      B: [true, true, false, true, true],
      I: [true, true, false, true, true],
      N: [false, false, true, false, false],
      G: [false, true, false, true, false],
      O: [true, false, false, false, true],
    },
    unusedLetters: ["N"],
    credit: "Claire Bickel",
  },
  {
    value: "2 Lines - One Vertical, One Horizontal",
    label: "2 Lines - One Vertical, One Horizontal",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, false],
      I: [true, false, false, false, false],
      N: [true, false, false, false, false],
      G: [true, true, true, true, true],
      O: [true, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "2 Stamps Anywhere — No Free Space",
    label: "2 Stamps Anywhere — No Free Space",
    otherNames: [],
    pattern: {
      B: [false, true, true, false, false],
      I: [false, true, true, false, false],
      N: [false, false, false, true, true],
      G: [false, false, false, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "2 Straight Lines",
    label: "2 Straight Lines",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, true, false, false, false],
      N: [false, true, false, false, false],
      G: [false, true, false, false, false],
      O: [false, true, false, false, false],
    },
    winningPatterns: [
      {
        B: [true, true, true, true, true],
        I: [true, false, false, false, false],
        N: [true, false, false, false, false],
        G: [true, false, false, false, false],
        O: [true, false, false, false, false],
      },
      {
        B: [false, true, false, false, false],
        I: [true, true, true, true, true],
        N: [false, true, false, false, false],
        G: [false, true, false, false, false],
        O: [false, true, false, false, false],
      },
      {
        B: [false, false, true, false, false],
        I: [false, false, true, false, false],
        N: [true, true, true, true, true],
        G: [false, false, true, false, false],
        O: [false, false, true, false, false],
      },
      {
        B: [false, false, false, true, false],
        I: [false, false, false, true, false],
        N: [false, false, false, true, false],
        G: [true, true, true, true, true],
        O: [false, false, false, true, false],
      },
      {
        B: [false, false, false, false, true],
        I: [false, false, false, false, true],
        N: [false, false, false, false, true],
        G: [false, false, false, false, true],
        O: [true, true, true, true, true],
      },
    ],
    unusedLetters: [],
    credit: "Convivial Kendrea",
  },
  {
    value: "23 And Free",
    label: "23 And Free",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [true, true, false, true, true],
      N: [true, true, true, true, true],
      G: [true, true, true, true, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, true, true, true, true],
        I: [true, true, true, true, true],
        N: [true, true, true, true, true],
        G: [false, true, true, true, true],
        O: [true, true, true, true, true],
      },
      {
        B: [true, true, true, true, true],
        I: [true, true, true, true, true],
        N: [true, true, true, true, true],
        G: [true, true, true, true, true],
        O: [true, true, false, true, true],
      },
      {
        B: [true, true, true, true, true],
        I: [true, true, true, true, false],
        N: [true, true, true, true, true],
        G: [true, true, true, true, true],
        O: [true, true, true, true, true],
      },
      {
        B: [true, true, true, true, true],
        I: [true, false, true, true, true],
        N: [true, true, true, true, true],
        G: [true, true, true, true, true],
        O: [true, true, true, true, true],
      },
    ],
  },
  {
    value: "2K",
    label: "2K",
    otherNames: [],
    pattern: {
      B: [true, false, true, true, true],
      I: [true, true, false, false, true],
      N: [true, true, true, true, true],
      G: [false, true, false, true, false],
      O: [true, false, false, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "3 Corner Postage Stamps",
    label: "3 Corner Postage Stamps",
    otherNames: ["Three Stamps, Three Postage Stamps", "Three Corner Postage Stamps", "3 Stamps", "3 Postage Stamps"],
    pattern: {
      B: [true, true, false, true, true],
      I: [true, true, false, true, true],
      N: [false, false, false, false, false],
      G: [true, true, false, false, false],
      O: [true, true, false, false, false],
    },
    winningPatterns: [
      {
        B: [true, true, false, true, true],
        I: [true, true, false, true, true],
        N: [false, false, false, false, false],
        G: [true, true, false, false, false],
        O: [true, true, false, false, false],
      },
      {
        B: [true, true, false, false, false],
        I: [true, true, false, false, false],
        N: [false, false, false, false, false],
        G: [true, true, false, true, true],
        O: [true, true, false, true, true],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [false, false, false, false, false],
        G: [true, true, false, true, true],
        O: [true, true, false, true, true],
      },
    ],
    unusedLetters: ["N"],
    credit: "Bret Rice",
  },
  {
    value: "3 Diagonal Lines",
    label: "3 Diagonal Lines",
    otherNames: [],
    pattern: {
      B: [false, false, true, false, true],
      I: [false, true, false, true, false],
      N: [true, false, true, false, true],
      G: [false, true, false, true, false],
      O: [true, false, true, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "3 Dot B And O",
    label: "3 Dot B And O",
    otherNames: [],
    pattern: {
      B: [false, true, true, true, false],
      I: [false, false, false, false, false],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, true, true, true, false],
    },
    unusedLetters: ["I", "N", "G"],
    credit: null,
  },
  {
    value: "3 Dots Diagonal Anywhere",
    label: "3 Dots Diagonal Anywhere",
    otherNames: [],
    pattern: {
      B: [false, false, true, false, false],
      I: [false, true, false, false, false],
      N: [true, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [false, false, true, false, false],
        I: [false, true, false, false, false],
        N: [true, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      { B: [false, false, false, true, false], I: [false, false, true, false, false], N: [false, true, false, false, false], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, true, false, false], N: [false, true, false, false, false], G: [true, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, true, false], G: [false, false, true, false, false], O: [false, true, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, true], N: [false, false, false, true, false], G: [false, false, true, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, false, true], G: [false, false, false, true, false], O: [false, false, true, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [true, false, false, false, false], G: [false, true, false, false, false], O: [false, false, true, false, false] },
      { B: [false, false, false, false, false], I: [true, false, false, false, false], N: [false, true, false, false, false], G: [false, false, true, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, true, false, false, false], G: [false, false, true, false, false], O: [false, false, false, true, false] },
      { B: [false, true, false, false, false], I: [false, false, true, false, false], N: [false, false, false, true, false], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, true, false, false], N: [false, false, false, true, false], G: [false, false, false, false, true], O: [false, false, false, false, false] },
      { B: [false, false, true, false, false], I: [false, false, false, true, false], N: [false, false, false, false, true], G: [false, false, false, false, false], O: [false, false, false, false, false] },
    ],
  },

  {
    value: "3 In The Corner",
    label: "3 In The Corner",
    otherNames: [],
    pattern: {
      B: [true, true, false, false, false],
      I: [true, false, false, false, false],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, true, false, false, false],
        I: [true, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [true, true, false, false, false],
        O: [false, true, false, false, false],
      },
      {
        B: [false, false, false, true, false],
        I: [false, false, false, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, true, true],
        O: [false, false, false, false, true],
      },
    ],
  },
  {
    value: "3 Leaf Clover",
    label: "3 Leaf Clover",
    otherNames: [],
    pattern: {
      B: [true, true, false, true, true],
      I: [true, true, false, true, true],
      N: [false, false, true, false, false],
      G: [true, true, false, true, false],
      O: [true, true, false, false, true],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "3 On Top 3 On Bottom",
    label: "3 On Top 3 On Bottom",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, true],
      I: [false, false, false, false, true],
      N: [true, false, false, false, false],
      G: [false, false, false, false, false],
      O: [true, false, false, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "3 On The Top And Bottom",
    label: "3 On The Top And Bottom",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, false],
      I: [false, false, false, false, true],
      N: [true, false, false, false, true],
      G: [false, false, false, false, true],
      O: [true, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, false, false, false, false],
        I: [false, false, false, false, true],
        N: [true, false, false, false, true],
        G: [false, false, false, false, true],
        O: [true, false, false, false, false],
      },
      {
        B: [false, false, false, false, true],
        I: [true, false, false, false, false],
        N: [false, false, false, false, true],
        G: [true, false, false, false, true],
        O: [true, false, false, false, false],
      },
      {
        B: [true, false, false, false, false],
        I: [true, false, false, false, true],
        N: [true, false, false, false, true],
        G: [false, false, false, false, true],
        O: [false, false, false, false, false],
      },
      {
        B: [true, false, false, false, false],
        I: [true, false, false, false, true],
        N: [false, false, false, false, true],
        G: [true, false, false, false, false],
        O: [false, false, false, false, true],
      },
    ],
  },
  {
    value: "3 Stamps, 3 Lines Anywhere",
    label: "3 Stamps, 3 Lines Anywhere",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, false],
      I: [true, true, true, true, false],
      N: [true, true, true, true, true],
      G: [true, true, true, true, false],
      O: [true, true, true, true, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "34",
    label: "34",
    otherNames: [],
    pattern: {
      B: [true, false, true, false, true],
      I: [true, true, true, true, true],
      N: [false, false, true, false, false],
      G: [false, true, true, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "4",
    label: "4",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [true, true, true, false, false],
      N: [false, false, true, false, false],
      G: [false, false, true, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["B", "N"],
    credit: "Monique Haeyn",
  },
  {
    value: "4 Card Hardway Triple Dot",
    label: "4 Card Hardway Triple Dot",
    otherNames: ["4 Card Hw Triple Dot"],
    pattern: {
      B: [true, false, false, false, false],
      I: [true, false, false, false, false],
      N: [true, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, false, false, false, false],
        I: [true, false, false, false, false],
        N: [true, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [true, true, true, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, true],
        G: [false, false, false, false, true],
        O: [false, false, false, false, true],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, true, true, true, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, true, false, false, false],
        N: [false, true, false, false, false],
        G: [false, true, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, true, true, true],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
    ],
  },
  {
    value: "4 Corners And A Line",
    label: "4 Corners And A Line",
    otherNames: ["4 Courners And A Line", "1 Ligne And 4 Corners", "Single Bingo Anywhere Plus 4 Corners"],
    pattern: {
      B: [true, false, false, false, true],
      I: [false, false, false, false, false],
      N: [false, false, false, false, false],
      G: [true, true, true, true, true],
      O: [true, false, false, false, true],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, false, false, false, true],
        I: [false, false, false, false, false],
        N: [true, true, true, true, true],
        G: [false, false, false, false, false],
        O: [true, false, false, false, true],
      },
      {
        B: [true, false, false, false, true],
        I: [true, true, true, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [true, false, false, false, true],
      },
      {
        B: [true, true, true, true, true],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [true, false, false, false, true],
      },
      {
        B: [true, false, false, false, true],
        I: [false, false, false, false, true],
        N: [false, false, false, false, true],
        G: [false, false, false, false, true],
        O: [true, false, false, false, true],
      },
      {
        B: [true, false, false, false, true],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [true, true, true, true, true],
      },
      {
        B: [true, false, false, true, true],
        I: [false, false, false, true, false],
        N: [false, false, false, true, false],
        G: [false, false, false, true, false],
        O: [true, false, false, true, true],
      },
      {
        B: [true, false, true, false, true],
        I: [false, false, true, false, false],
        N: [false, false, true, false, false],
        G: [false, false, true, false, false],
        O: [true, false, true, false, true],
      },
      {
        B: [true, true, false, false, true],
        I: [false, true, false, false, false],
        N: [false, true, false, false, false],
        G: [false, true, false, false, false],
        O: [true, true, false, false, true],
      },
      {
        B: [true, false, false, false, true],
        I: [true, false, false, false, false],
        N: [true, false, false, false, false],
        G: [true, false, false, false, false],
        O: [true, false, false, false, true],
      },
      {
        B: [true, false, false, false, true],
        I: [false, true, false, false, false],
        N: [false, false, true, false, false],
        G: [false, false, false, true, false],
        O: [true, false, false, false, true],
      },
      {
        B: [true, false, false, false, true],
        I: [false, false, false, true, false],
        N: [false, false, true, false, false],
        G: [false, true, false, false, false],
        O: [true, false, false, false, true],
      },
    ],
  },
  {
    value: "4 Corner",
    label: "4 Corner",
    otherNames: [],
    pattern: {
      B: [false, true, false, true, true],
      I: [true, true, false, true, true],
      N: [false, false, true, false, false],
      G: [true, true, false, true, true],
      O: [true, true, false, true, false],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "4 Corners",
    label: "4 Corners",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, true],
      I: [false, false, false, false, false],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [true, false, false, false, true],
    },
    unusedLetters: ["I", "N", "G"],
    credit: null,
  },
  {
    value: "4 Corner Postage Stamps",
    label: "4 Corner Postage Stamps",
    otherNames: ["Four Stamps", "4 Stamps", "4 Postage Stamps", "Four Postage Stamps"],
    pattern: {
      B: [true, true, false, true, true],
      I: [true, true, false, true, true],
      N: [false, false, false, false, false],
      G: [true, true, false, true, true],
      O: [true, true, false, true, true],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "4 Corners + Free Space",
    label: "4 Corners + Free Space",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, true],
      I: [false, false, false, false, false],
      N: [false, false, true, false, false],
      G: [false, false, false, false, false],
      O: [true, false, false, false, true],
    },
    unusedLetters: ["I", "N", "G"],
    credit: "Princess B",
  },
  {
    value: "4 Diagonal",
    label: "4 Diagonal",
    otherNames: ["4 Dots Diagonal"],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, true],
      N: [false, false, false, true, false],
      G: [false, false, true, false, false],
      O: [false, true, false, false, false],
    },
    unusedLetters: ["B"],
    credit: null,
  },
  {
    value: "4 Diagonal (Anywhere)",
    label: "4 Diagonal (Anywhere)",
    otherNames: ["4 Dots Diagonal Anywhere"],
    pattern: { B: [false, false, false, true, false], I: [false, false, true, false, false], N: [false, true, false, false, false], G: [true, false, false, false, false], O: [false, false, false, false, false] },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      { B: [false, false, false, true, false], I: [false, false, true, false, false], N: [false, true, false, false, false], G: [true, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, true], N: [false, false, false, true, false], G: [false, false, true, false, false], O: [false, true, false, false, false] },
      { B: [false, false, false, false, false], I: [true, false, false, false, false], N: [false, true, false, false, false], G: [false, false, true, false, false], O: [false, false, false, true, false] },
      { B: [false, true, false, false, false], I: [false, false, true, false, false], N: [false, false, false, true, false], G: [false, false, false, false, true], O: [false, false, false, false, false] },
    ],
  },
  {
    value: "4 x 4 As Shown",
    label: "4 x 4 As Shown",
    otherNames: ["Four by Four As Shown"],
    pattern: {
      B: [true, true, true, true, false],
      I: [true, true, true, true, false],
      N: [true, true, true, true, false],
      G: [true, true, true, true, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: null,
  },
  {
    value: "4 x 4 Anywhere",
    label: "4 x 4 Anywhere",
    otherNames: ["Four by Four Anywhere"],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, true, true, true, true],
      N: [false, true, true, true, true],
      G: [false, true, true, true, true],
      O: [false, true, true, true, true],
    },
    winningPatterns: [
      {
        B: [true, true, true, true, false],
        I: [true, true, true, true, false],
        N: [true, true, true, true, false],
        G: [true, true, true, true, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [true, true, true, true, false],
        N: [true, true, true, true, false],
        G: [true, true, true, true, false],
        O: [true, true, true, true, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, true, true, true, true],
        N: [false, true, true, true, true],
        G: [false, true, true, true, true],
        O: [false, true, true, true, true],
      },
      {
        B: [false, true, true, true, true],
        I: [false, true, true, true, true],
        N: [false, true, true, true, true],
        G: [false, true, true, true, true],
        O: [false, false, false, false, false],
      },
    ],
    unusedLetters: [],
    credit: null,
  },
  {
    value: "5 And 3 Anywhere",
    label: "5 And 3 Anywhere",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, true, true, true, false],
      N: [false, false, true, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: "Louise Durgin",
    winningPatterns: [
      {
        B: [true, true, true, true, true],
        I: [false, true, true, true, false],
        N: [false, false, true, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [true, true, true, true, true],
        I: [false, true, true, true, false],
        N: [false, false, true, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [true, false, false, false, false],
        I: [true, true, false, false, false],
        N: [true, true, true, false, false],
        G: [true, true, false, false, false],
        O: [true, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, true, false, false],
        G: [false, true, true, true, false],
        O: [true, true, true, true, true],
      },
      {
        B: [false, false, false, false, true],
        I: [false, false, false, true, true],
        N: [false, false, true, true, true],
        G: [false, false, false, true, true],
        O: [false, false, false, false, true],
      },
    ],
  },
  {
    value: "5 Around The Corner",
    label: "5 Around The Corner",
    otherNames: ["Five Around The Corner"],
    pattern: {
      B: [true, true, true, false, false],
      I: [true, false, false, false, false],
      N: [true, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "5k",
    label: "5k",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, true],
      I: [true, false, true, true, true],
      N: [true, true, true, true, true],
      G: [false, true, false, true, false],
      O: [true, false, false, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "6 Around The Corner",
    label: "6 Around The Corner",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, false],
      I: [true, false, false, false, false],
      N: [true, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "6 Circles",
    label: "6 Circles",
    otherNames: [],
    pattern: {
      B: [false, true, false, true, false],
      I: [false, false, false, false, false],
      N: [true, false, false, false, true],
      G: [false, false, false, false, false],
      O: [false, true, false, true, false],
    },
    unusedLetters: ["I", "G"],
    credit: null,
  },
  {
    value: "6 Pack, 9 Pack",
    label: "6 Pack, 9 Pack",
    otherNames: ["Six Pack, Nine Pack"],
    pattern: {
      B: [true, true, true, false, false],
      I: [true, true, true, false, false],
      N: [false, false, true, true, true],
      G: [false, false, true, true, true],
      O: [false, false, true, true, true],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, true, true, false, false],
        I: [true, true, true, false, false],
        N: [false, false, true, true, true],
        G: [false, false, true, true, true],
        O: [false, false, true, true, true],
      },
      {
        B: [true, true, true, false, false],
        I: [true, true, true, false, false],
        N: [true, true, true, false, false],
        G: [false, false, true, true, true],
        O: [false, false, true, true, true],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [true, true, true, true, true],
        G: [true, true, true, false, false],
        O: [true, true, true, false, false],
      },
    ],
  },
  {
    value: "6 Pack & Bingo No Overlap",
    label: "6 Pack & Bingo No Overlap",
    otherNames: ["Six Pack & Bingo No Overlap"],
    pattern: { B: [true, true, false, false, true], I: [true, true, false, true, false], N: [true, true, true, false, false], G: [false, true, false, false, false], O: [true, false, false, false, false] },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      { B: [true, true, false, false, true], I: [true, true, false, true, false], N: [true, true, true, false, false], G: [false, true, false, false, false], O: [true, false, false, false, false] },
      { B: [false, false, true, false, false], I: [false, false, true, false, false], N: [false, false, true, true, true], G: [false, false, true, true, true], O: [false, false, true, true, true] },
      { B: [false, false, false, false, false], I: [true, true, true, true, true], N: [false, false, false, false, false], G: [true, true, true, false, false], O: [true, true, true, false, false] },
      { B: [true, true, true, false, true], I: [true, true, true, false, true], N: [false, false, false, false, true], G: [false, false, false, false, true], O: [false, false, false, false, true] },
    ],
  },
  {
    value: "6 Pack As Shown",
    label: "6 Pack As Shown",
    otherNames: ["Six Pack As Shown"],
    pattern: {
      B: [true, true, false, false, false],
      I: [true, true, false, false, false],
      N: [true, true, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["G", "O"],
    credit: null,
  },
  {
    value: "6 Pack",
    label: "6 Pack",
    otherNames: ["Six Pack"],
    pattern: {
      B: [true, true, false, false, false],
      I: [true, true, false, false, false],
      N: [true, true, false, true, true],
      G: [false, false, false, true, true],
      O: [false, false, false, true, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "6 Pack & A Line",
    label: "6 Pack & A Line",
    otherNames: ["Six Pack & A Line"],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [false, false, false, false, false],
      G: [false, false, true, true, true],
      O: [false, false, true, true, true],
    },
    unusedLetters: [],
    credit: "CJ",
    winningPatterns: [
      {
        B: [true, true, true, true, true],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, false, true, true, true],
        O: [false, false, true, true, true],
      },
      {
        B: [false, false, true, true, true],
        I: [true, true, true, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, true, true, false, false],
        I: [false, true, true, false, false],
        N: [true, true, true, true, true],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [false, false, false, true, true],
        G: [true, true, true, true, true],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, true, true, true],
        N: [false, false, true, true, true],
        G: [false, false, false, false, false],
        O: [true, true, true, true, true],
      },
      {
        B: [true, false, false, false, false],
        I: [true, false, true, true, false],
        N: [true, false, true, true, false],
        G: [true, false, true, true, false],
        O: [true, false, false, false, false],
      },
      {
        B: [false, true, false, false, false],
        I: [false, true, false, false, false],
        N: [false, true, true, true, true],
        G: [false, true, true, true, true],
        O: [false, true, false, false, false],
      },
      {
        B: [false, false, true, false, false],
        I: [false, true, true, true, false],
        N: [false, true, true, true, false],
        G: [false, false, true, false, false],
        O: [false, false, true, false, false],
      },
      {
        B: [true, true, false, true, false],
        I: [true, true, false, true, false],
        N: [true, true, false, true, false],
        G: [false, false, false, true, false],
        O: [false, false, false, true, false],
      },
      {
        B: [false, false, false, false, true],
        I: [false, false, false, false, true],
        N: [false, false, false, true, true],
        G: [false, false, false, true, true],
        O: [false, false, false, true, true],
      },
      {
        B: [true, false, false, false, false],
        I: [false, true, false, false, false],
        N: [false, false, true, false, false],
        G: [true, true, true, true, false],
        O: [true, true, true, false, true],
      },
      {
        B: [false, false, false, false, true],
        I: [false, false, false, true, false],
        N: [true, true, true, false, false],
        G: [true, true, false, false, false],
        O: [true, true, false, false, false],
      },
    ],
  },
  {
    value: "6 Pack Anywhere",
    label: "6 Pack Anywhere",
    otherNames: ["Six Pack Anywhere", "Six Pack Abs"],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [false, false, false, false, false],
      G: [false, true, true, true, false],
      O: [false, true, true, true, false],
    },
    winningPatterns: [
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, true, true, true, false],
        O: [false, true, true, true, false],
      },
      {
        B: [true, true, true, false, false],
        I: [true, true, true, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [true, true, false, false, false],
        G: [true, true, false, false, false],
        O: [true, true, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, true, true, true, false],
        N: [false, true, true, true, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, true, true],
        G: [false, false, false, true, true],
        O: [false, false, false, true, true],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, true, true, true],
        N: [false, false, true, true, true],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, true, true, false, false],
        I: [false, true, true, false, false],
        N: [false, true, true, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
    ],
    unusedLetters: [],
    credit: null,
  },
  {
    value: "6 Pack Anywhere (Alternate)",
    label: "6 Pack Anywhere (Alternate)",
    otherNames: ["Six Pack Anywhere", "6 Pack Anywhere"],
    pattern: {
      B: [true, true, true, false, false],
      I: [true, true, true, false, false],
      N: [false, false, false, true, true],
      G: [false, false, false, true, true],
      O: [false, false, false, true, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "6 Pack Anywhere (No Free Space)",
    label: "6 Pack Anywhere (No Free Space)",
    otherNames: ["Six Pack Anywhere (No Free Space)"],
    pattern: {
      B: [true, true, true, false, false],
      I: [true, true, true, false, false],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, true, true, false, false],
        I: [true, true, true, false, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [true, true, false, false, false],
        G: [true, true, false, false, false],
        O: [true, true, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [false, true, true, true, false],
        O: [false, true, true, true, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, true, true],
        G: [false, false, false, true, true],
        O: [false, false, false, true, true],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, true, true],
        N: [false, false, false, true, true],
        G: [false, false, false, true, true],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, true, true],
        I: [false, false, false, true, true],
        N: [false, false, false, true, true],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, true, true, true],
        I: [false, false, true, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, true, true, true, false],
        I: [false, true, true, true, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
    ],
  },
  {
    value: "7 - 11",
    label: "7 - 11",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, false],
      I: [true, true, true, true, true],
      N: [false, false, false, false, false],
      G: [true, true, true, true, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "7 - 11 (Alternate)",
    label: "7 - 11 (Alternate)",
    otherNames: [],
    pattern: {
      B: [true, false, true, false, false],
      I: [true, true, false, false, false],
      N: [true, false, false, false, false],
      G: [false, false, true, true, true],
      O: [false, false, true, true, true],
    },
    unusedLetters: [],
    credit: "Alissa Wagoner",
  },
  {
    value: "7 Around 2 Corners - No Ns",
    label: "7 Around 2 Corners - No Ns",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [true, false, false, false, true],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["N"],
    credit: "Richard Ortiz",
    winningPatterns: [
      {
        B: [true, true, true, true, true],
        I: [true, false, false, false, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [true, false, false, false, true],
        O: [true, true, true, true, true],
      },
    ],
  },
  {
    value: "7 Number Inch Worm — Any 7 Numbers (Continuous)",
    label: "7 Number Inch Worm — Any 7 Numbers (Continuous)",
    otherNames: [],
    pattern: {
      B: [false, false, true, false, false],
      I: [false, true, true, false, false],
      N: [false, false, false, true, false],
      G: [true, false, true, false, false],
      O: [false, true, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "7 On Top and Bottom",
    label: "7 On Top and Bottom",
    otherNames: ["Seven on Top and Bottom"],
    pattern: {
      B: [true, false, false, false, true],
      I: [true, false, false, false, false],
      N: [false, false, false, false, true],
      G: [true, false, false, false, true],
      O: [false, false, false, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "8 Anywhere - No Free Space",
    label: "8 Anywhere - No Free Space",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, true],
      I: [true, false, true, false, false],
      N: [false, true, false, true, false],
      G: [true, false, false, false, true],
      O: [false, true, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [false, false, false, false, true],
        I: [true, false, true, false, false],
        N: [false, true, false, true, false],
        G: [true, false, false, false, true],
        O: [false, true, false, false, false],
      },
      {
        B: [true, false, false, true, false],
        I: [false, true, false, false, true],
        N: [false, false, false, true, false],
        G: [false, false, false, false, true],
        O: [true, false, true, false, false],
      },
      {
        B: [true, false, true, false, false],
        I: [false, false, false, true, false],
        N: [false, true, false, false, true],
        G: [false, false, true, false, false],
        O: [true, false, false, false, true],
      },
      {
        B: [true, false, false, false, true],
        I: [false, true, false, true, false],
        N: [false, false, false, false, false],
        G: [true, true, false, false, true],
        O: [false, false, true, false, false],
      },
    ],
  },
  {
    value: "8 Dotes",
    label: "8 Dotes",
    otherNames: ["8 Dots"],
    pattern: {
      B: [true, false, true, false, true],
      I: [false, false, false, false, false],
      N: [false, true, false, true, false],
      G: [false, false, false, false, false],
      O: [true, false, true, false, true],
    },
    unusedLetters: ["I", "G"],
    credit: null,
  },
  {
    value: "8 Middle",
    label: "8 Middle",
    otherNames: [],
    pattern: {
      B: [false, true, false, true, false],
      I: [true, false, false, false, true],
      N: [false, false, false, false, false],
      G: [true, false, false, false, true],
      O: [false, true, false, true, false],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "8 Pack As Shown",
    label: "8 Pack As Shown",
    otherNames: ["Eight Pack As Shown"],
    pattern: {
      B: [false, false, false, true, true],
      I: [false, false, false, true, true],
      N: [false, false, false, true, true],
      G: [false, false, false, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: null,
  },
  {
    value: "8 Pack Anywhere",
    label: "8 Pack Anywhere",
    otherNames: ["Eight Pack Anywhere"],
    pattern: {
      B: [true, true, false, false, false],
      I: [true, true, false, false, false],
      N: [true, true, false, false, false],
      G: [true, true, false, false, false],
      O: [false, false, false, false, false],
    },
    winningPatterns: [
      {
        B: [true, true, false, false, false],
        I: [true, true, false, false, false],
        N: [true, true, false, false, false],
        G: [true, true, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, false, false, false],
        G: [true, true, true, true, false],
        O: [true, true, true, true, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, true, true],
        N: [false, false, false, true, true],
        G: [false, false, false, true, true],
        O: [false, false, false, true, true],
      },
      {
        B: [false, true, true, true, true],
        I: [false, true, true, true, true],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, true, true, false],
        I: [false, false, true, true, false],
        N: [false, false, true, true, false],
        G: [false, false, true, true, false],
        O: [false, false, false, false, false],
      },
      {
        B: [true, true, true, true, false],
        I: [true, true, true, true, false],
        N: [false, false, false, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
    ],
    unusedLetters: [],
    credit: null,
  },
  {
    value: "8 Parallel",
    label: "8 Parallel",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, false],
      I: [true, true, true, true, false],
      N: [false, false, false, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      { B: [true, true, true, true, false], I: [true, true, true, true, false], N: [false, false, false, false, false], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [true, true, false, false, false], I: [true, true, false, false, false], N: [true, true, false, false, false], G: [true, true, false, false, false], O: [false, false, false, false, false] },
      { B: [false, true, true, true, true], I: [false, true, true, true, true], N: [false, false, false, false, false], G: [false, false, false, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, true, true], I: [false, false, false, true, true], N: [false, false, false, true, true], G: [false, false, false, true, true], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, true, true], N: [false, false, false, true, true], G: [false, false, false, true, true], O: [false, false, false, true, true] },
      { B: [false, false, false, false, false], I: [true, true, false, false, false], N: [true, true, false, false, false], G: [true, true, false, false, false], O: [true, true, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [true, true, true, true, false], O: [true, true, true, true, false] },
      { B: [false, false, false, false, false], I: [false, false, false, false, false], N: [false, false, false, false, false], G: [false, true, true, true, true], O: [false, true, true, true, true] },
      { B: [false, true, true, false, false], I: [false, true, true, false, false], N: [false, true, true, false, false], G: [false, true, true, false, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, true, true, false, false], N: [false, true, true, false, false], G: [false, true, true, false, false], O: [false, true, true, false, false] },
      { B: [false, false, true, true, false], I: [false, false, true, true, false], N: [false, false, true, true, false], G: [false, false, true, true, false], O: [false, false, false, false, false] },
      { B: [false, false, false, false, false], I: [false, false, true, true, false], N: [false, false, true, true, false], G: [false, false, true, true, false], O: [false, false, true, true, false] },
    ],
  },
  {
    value: "9 Pack As Shown",
    label: "9 Pack As Shown",
    otherNames: ["Nine Pack As Shown"],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [false, false, true, true, true],
      G: [false, false, true, true, true],
      O: [false, false, true, true, true],
    },
    unusedLetters: ["B", "I"],
    credit: null,
  },
  {
    value: "9 Pack Anywhere",
    label: "9 Pack Anywhere",
    otherNames: ["Nine Pack Anywhere"],
    pattern: {
      B: [false, false, false, false, false],
      I: [true, true, true, false, false],
      N: [true, true, true, false, false],
      G: [true, true, true, false, false],
      O: [false, false, false, false, false],
    },
    winningPatterns: [
      {
        B: [true, true, true, false, false],
        I: [true, true, true, false, false],
        N: [true, true, true, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [true, true, true, false, false],
        N: [true, true, true, false, false],
        G: [true, true, true, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [true, true, true, false, false],
        G: [true, true, true, false, false],
        O: [true, true, true, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, true, true, true, false],
        G: [false, true, true, true, false],
        O: [false, true, true, true, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, true, true, true],
        G: [false, false, true, true, true],
        O: [false, false, true, true, true],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, true, true, true],
        N: [false, false, true, true, true],
        G: [false, false, true, true, true],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, true, true, true],
        I: [false, false, true, true, true],
        N: [false, false, true, true, true],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, true, true, true, false],
        I: [false, true, true, true, false],
        N: [false, true, true, true, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, true, true, true, false],
        N: [false, true, true, true, false],
        G: [false, true, true, true, false],
        O: [false, false, false, false, false],
      },
    ],
    unusedLetters: [],
    credit: null,
  },
  {
    value: "9 Pack Corners",
    label: "9 Pack Corners",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, false],
      I: [true, true, true, false, false],
      N: [true, true, true, false, false],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
    winningPatterns: [
      {
        B: [true, true, true, false, false],
        I: [true, true, true, false, false],
        N: [true, true, true, false, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, true, true, true],
        I: [false, false, true, true, true],
        N: [false, false, true, true, true],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [true, true, true, false, false],
        G: [true, true, true, false, false],
        O: [true, true, true, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, false, true, true, true],
        G: [false, false, true, true, true],
        O: [false, false, true, true, true],
      },
    ],
  },
  {
    value: "9 Pack Upper Right",
    label: "9 Pack Upper Right",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [true, true, true, false, false],
      G: [true, true, true, false, false],
      O: [true, true, true, false, false],
    },
    unusedLetters: ["B", "I"],
    credit: "Craig D Miller",
  },
  {
    value: "12 Pack As Shown",
    label: "12 Pack As Shown",
    otherNames: ["Twelve Pack As Shown"],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [true, true, true, true, false],
      G: [true, true, true, true, false],
      O: [true, true, true, true, false],
    },
    unusedLetters: ["B", "I"],
    credit: null,
  },
  {
    value: "12 Pack Anywhere",
    label: "12 Pack Anywhere",
    otherNames: ["Twelve Pack Anywhere"],
    pattern: {
      B: [false, true, true, true, false],
      I: [false, true, true, true, false],
      N: [false, true, true, true, false],
      G: [false, true, true, true, false],
      O: [false, false, false, false, false],
    },
    winningPatterns: [
      {
        B: [true, true, true, false, false],
        I: [true, true, true, false, false],
        N: [true, true, true, false, false],
        G: [true, true, true, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [true, true, true, false, false],
        N: [true, true, true, false, false],
        G: [true, true, true, false, false],
        O: [true, true, true, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [true, true, true, true, false],
        G: [true, true, true, true, false],
        O: [true, true, true, true, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, false, false, false],
        N: [false, true, true, true, true],
        G: [false, true, true, true, true],
        O: [false, true, true, true, true],
      },
      {
        B: [false, false, false, false, false],
        I: [false, false, true, true, true],
        N: [false, false, true, true, true],
        G: [false, false, true, true, true],
        O: [false, false, true, true, true],
      },
      {
        B: [false, false, true, true, true],
        I: [false, false, true, true, true],
        N: [false, false, true, true, true],
        G: [false, false, true, true, true],
        O: [false, false, false, false, false],
      },
      {
        B: [false, true, true, true, true],
        I: [false, true, true, true, true],
        N: [false, true, true, true, true],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [true, true, true, true, false],
        I: [true, true, true, true, false],
        N: [true, true, true, true, false],
        G: [false, false, false, false, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, true, true, true, false],
        I: [false, true, true, true, false],
        N: [false, true, true, true, false],
        G: [false, true, true, true, false],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, true, true, true, false],
        N: [false, true, true, true, false],
        G: [false, true, true, true, false],
        O: [false, true, true, true, false],
      },
      {
        B: [false, false, false, false, false],
        I: [false, true, true, true, true],
        N: [false, true, true, true, true],
        G: [false, true, true, true, true],
        O: [false, false, false, false, false],
      },
      {
        B: [false, false, false, false, false],
        I: [true, true, true, true, false],
        N: [true, true, true, true, false],
        G: [true, true, true, true, false],
        O: [false, false, false, false, false],
      },
    ],
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 0",
    label: "Number 0",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, true, true, true, false],
      N: [true, false, false, false, true],
      G: [true, false, false, false, true],
      O: [false, true, true, true, false],
    },
    unusedLetters: ["B"],
    credit: null,
  },
  {
    value: "Number 1",
    label: "Number 1",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, true, false, false, true],
      N: [true, true, true, true, true],
      G: [false, false, false, false, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["B", "O"],
    credit: null,
  },
  {
    value: "Number 1 (Alternate)",
    label: "Number 1 (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, true, false, false, false],
      N: [true, true, true, true, true],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["B", "G", "O"],
    credit: null,
  },

  {
    value: "Number 1 (Alternate 2)",
    label: "Number 1 (Alternate 2)",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, true],
      I: [true, false, false, false, true],
      N: [true, true, true, true, true],
      G: [false, false, false, false, true],
      O: [false, false, false, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 1 (Alternate 3)",
    label: "Number 1 (Alternate 3)",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, true],
      I: [false, true, false, false, true],
      N: [true, true, true, true, true],
      G: [false, false, false, false, true],
      O: [false, false, false, false, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 2",
    label: "Number 2",
    otherNames: [],
    pattern: {
      B: [true, false, false, true, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [false, true, false, false, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: null,
  },
  {
    value: "Number 2 (Alternate)",
    label: "Number 2 (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, true, false, false, true],
      I: [true, false, false, true, true],
      N: [true, false, true, false, true],
      G: [false, true, false, false, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: "VFW Post 3596",
  },
  {
    value: "Number 3",
    label: "Number 3",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: null,
  },
  {
    value: "Number 3 (Alternate)",
    label: "Number 3 (Alternate)",
    otherNames: [],
    pattern: {
      B: [true, false, true, false, true],
      I: [true, false, true, false, true],
      N: [true, true, true, true, true],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["G", "O"],
    credit: null,
  },
  {
    value: "Number 3 (Alternate 2)",
    label: "Number 3 (Alternate 2)",
    otherNames: ["Big 3", "Big Three", "Number Three"],
    pattern: {
      B: [true, false, false, false, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, true, false, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 3 (Reversed)",
    label: "Number 3 (Reversed)",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, false, false, false, false],
      N: [true, true, true, true, true],
      G: [true, false, true, false, true],
      O: [true, false, true, false, true],
    },
    unusedLetters: ["B", "I"],
    credit: null,
  },
  {
    value: "Number 4",
    label: "Number 4",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, false],
      I: [false, false, true, false, false],
      N: [false, false, true, false, false],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["N", "O"],
    credit: null,
  },
  {
    value: "Number 4 (Alternate)",
    label: "Number 4 (Alternate)",
    otherNames: ["4 H"],
    pattern: {
      B: [false, false, false, false, false],
      I: [true, true, true, false, false],
      N: [false, false, true, false, false],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["B", "N", "O"],
    credit: null,
  },
  {
    value: "Number 4 (Alternate 2)",
    label: "Number 4 (Alternate 2)",
    otherNames: [],
    pattern: {
      B: [false, false, true, true, false],
      I: [false, true, false, true, false],
      N: [true, false, false, true, false],
      G: [true, true, true, true, true],
      O: [false, false, false, true, false],
    },
    unusedLetters: [],
    credit: "Bee",
  },
  {
    value: "Number 4 (Alternate 3)",
    label: "Number 4 (Alternate 3)",
    otherNames: [],
    pattern: {
      B: [false, false, false, true, false],
      I: [false, false, true, true, false],
      N: [false, true, false, true, false],
      G: [true, true, true, true, true],
      O: [false, false, false, true, false],
    },
    unusedLetters: [],
    credit: "Erica S",
  },
  {
    value: "Number 5",
    label: "Number 5",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: null,
  },
  {
    value: "Number 5 (Alternate)",
    label: "Number 5 (Alternate)",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, false, true, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: "VFW Post 3596",
  },
  {
    value: "Number 5 (Alternate 2)",
    label: "Number 5 (Alternate 2)",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, true, false, true],
      O: [true, false, false, true, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 6",
    label: "Number 6",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: null,
  },
  {
    value: "Number 6 (Alternate)",
    label: "Number 6 (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, true, true, true, false],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [false, false, false, true, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: "VFW Post 3596",
  },
  {
    value: "Number 7",
    label: "Number 7",
    otherNames: [],
    pattern: {
      B: [true, false, false, false, true],
      I: [true, false, false, true, false],
      N: [true, false, true, false, false],
      G: [true, true, false, false, false],
      O: [true, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 7 With Tail",
    label: "Number 7 With Tail",
    otherNames: ["Number 7 W/ Tail"],
    pattern: {
      B: [true, true, false, false, true],
      I: [true, false, false, true, false],
      N: [true, false, true, false, false],
      G: [true, true, false, false, false],
      O: [true, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 8",
    label: "Number 8",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["O"],
    credit: null,
  },
  {
    value: "Number 8 (Alternate)",
    label: "Number 8 (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [false, true, false, true, false],
      N: [true, false, true, false, true],
      G: [true, false, true, false, true],
      O: [false, true, false, true, false],
    },
    unusedLetters: ["B"],
    credit: null,
  },
  {
    value: "Number 8 (Alternate 2)",
    label: "Number 8 (Alternate 2)",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [true, false, true, false, true],
      N: [true, false, true, false, true],
      G: [true, false, true, false, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 9",
    label: "Number 9",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, false],
      I: [true, false, true, false, false],
      N: [true, false, true, false, false],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 9 (Alternate)",
    label: "Number 9 (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [true, true, true, false, false],
      N: [true, false, true, false, false],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["B", "O"],
    credit: null,
  },
  {
    value: "Number 9 (Alternate 2)",
    label: "Number 9 (Alternate 2)",
    otherNames: [],
    pattern: {
      B: [false, false, false, false, false],
      I: [true, true, true, false, true],
      N: [true, false, true, false, true],
      G: [true, true, true, true, true],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["B", "O"],
    credit: null,
  },
  {
    value: "Number 10",
    label: "Number 10",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, true, true],
      G: [true, false, false, false, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 11",
    label: "Number 11",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, true, true],
      G: [false, false, false, false, false],
      O: [false, false, false, false, false],
    },
    unusedLetters: ["I", "G", "O"],
    credit: null,
  },
  {
    value: "Number 11 (Alternate)",
    label: "Number 11 (Alternate)",
    otherNames: [],
    pattern: {
      B: [false, true, false, false, false],
      I: [true, true, true, true, true],
      N: [false, false, false, false, false],
      G: [false, true, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["N"],
    credit: null,
  },
  {
    value: "Number 12",
    label: "Number 12",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, false, true, true, true],
      G: [true, false, true, false, true],
      O: [true, true, true, false, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 13",
    label: "Number 13",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, false, true, false, true],
      G: [true, false, true, false, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 14",
    label: "Number 14",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, false, false],
      G: [false, false, true, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 15",
    label: "Number 15",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, false, true],
      G: [true, false, true, false, true],
      O: [true, false, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 16",
    label: "Number 16",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, true, true],
      G: [true, false, true, false, true],
      O: [true, false, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 17",
    label: "Number 17",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, false, false, false, false],
      G: [true, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 17 (Alternate)",
    label: "Number 17 (Alternate)",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, false, false, false],
      G: [true, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 18",
    label: "Number 18",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, true, true],
      G: [true, false, true, false, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 19",
    label: "Number 19",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, false, false],
      G: [true, false, true, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 19 (Alternate)",
    label: "Number 19 (Alternate)",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [false, false, false, false, false],
      N: [true, true, true, false, true],
      G: [true, false, true, false, true],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["I"],
    credit: null,
  },
  {
    value: "Number 21",
    label: "Number 21",
    otherNames: [],
    pattern: {
      B: [true, false, true, true, true],
      I: [true, false, true, false, true],
      N: [true, true, true, false, true],
      G: [false, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["G"],
    credit: "VFW Post 3596",
  },
  {
    value: "Number 25",
    label: "Number 25",
    otherNames: [],
    pattern: {
      B: [true, false, true, true, true],
      I: [true, true, true, false, true],
      N: [true, true, true, false, true],
      G: [true, false, true, false, true],
      O: [true, false, true, true, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 37",
    label: "Number 37",
    otherNames: [],
    pattern: {
      B: [true, false, true, false, true],
      I: [true, true, true, true, true],
      N: [true, false, false, false, false],
      G: [true, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: [],
    credit: null,
  },
  {
    value: "Number 41",
    label: "Number 41",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, false],
      I: [false, false, true, false, false],
      N: [true, true, true, true, true],
      G: [false, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["G"],
    credit: "VFW Post 3596",
  },
  {
    value: "Number 51",
    label: "Number 51",
    otherNames: [],
    pattern: {
      B: [true, true, true, false, true],
      I: [true, false, true, false, true],
      N: [true, false, true, true, true],
      G: [false, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["G"],
    credit: "VFW Post 3596",
  },
  {
    value: "Number 61",
    label: "Number 61",
    otherNames: [],
    pattern: {
      B: [true, true, true, true, true],
      I: [true, false, true, false, true],
      N: [true, false, true, true, true],
      G: [false, false, false, false, false],
      O: [true, true, true, true, true],
    },
    unusedLetters: ["G"],
    credit: "VFW Post 3596",
  },
];
